import { defineMessages } from "react-intl"

export const notificationPopoverContentMessages = defineMessages({
	expandableShowMore: {
		defaultMessage: "Show {count} more",
		id: "notificationPopover.expandableShowMore",
	},
	heading: {
		defaultMessage: "Latest Notifications and Tasks",
		id: "notificationPopover.heading",
	},
	link: {
		defaultMessage: "View all Notifications and Tasks",
		id: "notificationPopover.link",
	},
})
